import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./About.css";

const About = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
      },
    },
  };

  const stats = [
    { number: "30+", label: "Projects Completed" },
    { number: "5+", label: "Years Experience" },
    { number: "15+", label: "Happy Clients" },
    { number: "100%", label: "Code Quality" },
  ];

  return (
    <section id="about" className="about section" ref={ref}>
      <div className="about-container">
        <motion.div
          className="about-content terminal-window"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <div className="terminal-header">
            <div className="terminal-buttons">
              <span className="terminal-button red"></span>
              <span className="terminal-button yellow"></span>
              <span className="terminal-button green"></span>
            </div>
            <div className="terminal-title">~/about.txt</div>
          </div>
          <motion.div className="section-header" variants={itemVariants}>
            <h2>About Me</h2>
          </motion.div>
          <motion.p variants={itemVariants}>
            Hello! I'm <span className="highlight">GHALI Faiçal</span>, an Electromechanical Engineer and passionate Full
            Stack Developer with a love for creating dynamic and user-friendly
            web applications. My journey in tech started with a fascination for
            how things work, which led me to master both frontend and backend
            technologies, as well as hardware and IoT systems.
          </motion.p>
          <motion.p variants={itemVariants}>
            I thrive on solving complex problems and enjoy turning ideas into
            reality. Whether it's building a sleek user interface with{" "}
            <span className="highlight">React</span>, a robust API with{" "}
            <span className="highlight">Node.js</span>, or working with{" "}
            <span className="highlight">Arduino</span> and{" "}
            <span className="highlight">Raspberry Pi</span>, I am dedicated to
            writing clean, efficient, and scalable code.
          </motion.p>
        </motion.div>

        <motion.div
          className="about-stats"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                className="stat-item glass"
                variants={itemVariants}
                whileHover={{ scale: 1.05, y: -5 }}
              >
                <div className="stat-number neon-text">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
